import styles from "./DefaultBid.module.scss";
import Checkbox from "../../../../../components/common/Checkbox/Checkbox";
import { Col, Input, Row } from "reactstrap";
import { GiPanda } from "react-icons/gi";
import Toggle from "../../../../../components/common/Toggle/Toggle";

const DefaultBid = () => {
  return (
    <div>
      <div className={styles["heading"]}>Default Bid</div>
      <div className="p-2 bg-white">
        <div className={styles["wrapper"]}>
          <div>Select preferred option</div>

          <div className="d-flex gap-2 px-lg-3">
            <div className="mt-1">
              <Checkbox />
            </div>
            <div>
              <div>Set default bid</div>
              <Input type="number" placeholder="$1.00" />
            </div>
          </div>
          <div className="d-flex gap-2 px-lg-3 mt-3">
            <div className="mt-1">
              <Checkbox />
            </div>
            <div>
              <div>Set bids by targeting groups</div>
            </div>
          </div>

          <div className={styles.bidTargetContainer}>
            <Row className="g-0 fw-semibold">
              <Col xs={2} xxl={1}>Status</Col>
              <Col xs={5} xxl={3}>Targeting Group</Col>
              <Col xs={5} xxl={3}>Bid</Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={2} xxl={1} className="d-flex align-items-center">
                <Toggle />
              </Col>
              <Col xs={5} xxl={3} className="fw-medium">
                Exact Fit
              </Col>
              <Col xs={3}>
                <Input type="number" placeholder="$1.00" />
              </Col>
              <Col xs={2}>
                <div className={styles.suggestionText}>
                  <GiPanda size={18} className={styles.pandaImg} />
                  $2.00
                </div>
              </Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={2} xxl={1} className="d-flex align-items-center">
                <Toggle />
              </Col>
              <Col xs={5} xxl={3} className="fw-medium">
                Broad Reach
              </Col>
              <Col xs={3}>
                <Input type="number" placeholder="$1.00" />
              </Col>
              <Col xs={2}>
                <div className={styles.suggestionText}>
                  <GiPanda size={18} className={styles.pandaImg} />
                  $1.50
                </div>
              </Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={2} xxl={1} className="d-flex align-items-center">
                <Toggle />
              </Col>
              <Col xs={5} xxl={3} className="fw-medium">
                Similar Alternatives
              </Col>
              <Col xs={3}>
                <Input type="number" placeholder="$1.00" />
              </Col>
              <Col xs={2}>
                <div className={styles.suggestionText}>
                  <GiPanda size={18} className={styles.pandaImg} />
                  $1.00
                </div>
              </Col>
            </Row>
            <Row className="g-0 align-items-center">
              <Col xs={2} xxl={1} className="d-flex align-items-center">
                <Toggle />
              </Col>
              <Col xs={5} xxl={3} className="fw-medium">
                Additional Accessories
              </Col>
              <Col xs={3}>
                <Input type="number" placeholder="$1.00" />
              </Col>
              <Col xs={2}>
                <div className={styles.suggestionText}>
                  <GiPanda size={18} className={styles.pandaImg} />
                  $0.75
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DefaultBid;